import React from "react";
import {
  knox_logo,
  satm_logo,
  stressops_logo,
  duwise_logo,
  orcaflo_logo,
  qufree_logo,
  cxo_logo,
  marketplace_knoxHR as marketplaceKnoxHR,
  marketplace_duwise as marketplaceDuwise,
  marketplace_qufree as marketplaceQufree,
  marketplace_cxotulz as marketplaceCxotulz,
  marketplace_satm as marketplaceSATM,
  marketplace_orkaflo as marketplaceOrkaflo,
  marketplace_stressops as marketplaceStressOps,
} from "src/shared/utils/appConstant";

interface LogoProps {
  id: string;
  className?: string;
  vertical?: boolean;
}

export const ProductLogo: React.FC<LogoProps> = ({ id, className = "", vertical = false }) => {
  switch (id) {
    case "knoxhr":
      if (vertical) {
        return (
          <div className={`brand-logo-wrap brand-knoxhr vertical-svg-wrap ${className}`}>
            <img
              src={marketplaceKnoxHR}
              alt="KnoxHR"
              className="brand-vertical-svg"
            />
          </div>
        );
      }
      return (
        <div className={`brand-logo-wrap brand-knoxhr ${className}`}>
          <img
            src={knox_logo}
            alt="KnoxHR"
            className="brand-icon"
            style={{ width: 34, height: 34, objectFit: "contain" }}
          />
          <span className="brand-text">
            <strong>Knox</strong>HR
          </span>
        </div>
      );

    case "orkaflo":
    case "orcaflo":
      if (vertical) {
        return (
          <div className={`brand-logo-wrap brand-orkaflo vertical-svg-wrap ${className}`}>
            <img
              src={marketplaceOrkaflo}
              alt="Orkaflo"
              className="brand-vertical-svg"
              style={{ transform: "scale(1.2)", transformOrigin: "center" }}
            />
          </div>
        );
      }
      return (
        <div className={`brand-logo-wrap brand-orcaflo brand-orkaflo ${className}`}>
          <img
            src={orcaflo_logo}
            alt="Orkaflo"
            className="brand-icon"
            style={{ width: 34, height: 34, objectFit: "contain" }}
          />
          <span className="brand-text">
            Orkaflo
          </span>
        </div>
      );

    case "satm":
      if (vertical) {
        return (
          <div className={`brand-logo-wrap brand-satm vertical-svg-wrap ${className}`}>
            <img
              src={marketplaceSATM}
              alt="SATM"
              className="brand-vertical-svg"
              style={{ transform: "scale(0.85)", transformOrigin: "center" }}
            />
          </div>
        );
      }
      return (
        <div className={`brand-logo-wrap brand-satm ${className}`}>
          <img
            src={satm_logo}
            alt="SATM"
            className="brand-icon"
            style={{ width: 34, height: 34, objectFit: "contain" }}
          />
          <span className="brand-text">
            <strong>SATM</strong>
          </span>
        </div>
      );

    case "duwise":
      if (vertical) {
        return (
          <div className={`brand-logo-wrap brand-duwise vertical-svg-wrap ${className}`}>
            <img
              src={marketplaceDuwise}
              alt="DuWise"
              className="brand-vertical-svg"
            />
          </div>
        );
      }
      return (
        <div className={`brand-logo-wrap brand-duwise ${className}`}>
          <img
            src={duwise_logo}
            alt="DuWise"
            className="brand-icon"
            style={{ width: 34, height: 34, objectFit: "contain" }}
          />
          <span className="brand-text">
            <strong>Du</strong>Wise
          </span>
        </div>
      );

    case "qufree":
      if (vertical) {
        return (
          <div className={`brand-logo-wrap brand-qufree vertical-svg-wrap ${className}`}>
            <img
              src={marketplaceQufree}
              alt="QuFree"
              className="brand-vertical-svg"
            />
          </div>
        );
      }
      return (
        <div className={`brand-logo-wrap brand-qufree ${className}`}>
          <img
            src={qufree_logo}
            alt="QuFree"
            className="brand-icon"
            style={{ width: 34, height: 34, objectFit: "contain" }}
          />
          <span className="brand-text">
            <strong>Qu</strong>Free
          </span>
        </div>
      );

    case "stressops":
      if (vertical) {
        return (
          <div className={`brand-logo-wrap brand-stressops vertical-svg-wrap ${className}`}>
            <img
              src={marketplaceStressOps}
              alt="StressOps"
              className="brand-vertical-svg"
            />
          </div>
        );
      }
      return (
        <div className={`brand-logo-wrap brand-stressops ${className}`}>
          <img
            src={stressops_logo}
            alt="StressOps"
            className="brand-icon"
            style={{ width: 34, height: 34, objectFit: "contain" }}
          />
          <span className="brand-text">
            <strong>Stress</strong>Ops
          </span>
        </div>
      );

    case "cxotulz":
      if (vertical) {
        return (
          <div className={`brand-logo-wrap brand-cxotulz vertical-svg-wrap ${className}`}>
            <img
              src={marketplaceCxotulz}
              alt="CXOTulz"
              className="brand-vertical-svg"
            />
          </div>
        );
      }
      return (
        <div className={`brand-logo-wrap brand-cxotulz ${className}`}>
          <img
            src={cxo_logo}
            alt="CXOTulz"
            className="brand-icon"
            style={{ width: 34, height: 34, objectFit: "contain" }}
          />
          <span className="brand-text">
            <strong>CXO</strong>Tulz
          </span>
        </div>
      );

    default:
      return <span className="brand-text">{id}</span>;
  }
};
